import { render, staticRenderFns } from "./ArticleQuestions.vue?vue&type=template&id=4e1341cb&scoped=true&"
import script from "./ArticleQuestions.vue?vue&type=script&lang=js&"
export * from "./ArticleQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ArticleQuestions.vue?vue&type=style&index=0&id=4e1341cb&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1341cb",
  null
  
)

export default component.exports